const permissions = {
  accounts: {
    'read:own': ['*'],
  },
  drafts: {
    'create:own': ['*'],
    'read:own': ['*'],
    'update:own': ['*'],
    'delete:own': ['*'],
  },
  contents: {
    'read:any': ['*'],
    'update:any': ['*'],
    'delete:any': ['*'],
  },
  dashboards: {
    'read:own': ['*'],
  },
  discussions: {
    'create:own': ['*'],
    'read:own': ['*'],
    'update:own': ['*'],
    'delete:own': ['*'],
  },
  files: {
    'read:own': ['*'],
  },
  activities: {
    'read:own': ['*'],
    'update:own': ['*'],
  },
  automations: {
    'read:own': ['*'],
  },
  users: {
    'read:own': ['*'],
    'update:own': ['*'],
    'delete:own': ['*'],
  },
}

export default permissions
